import { Button, Grid, TextField, MenuItem } from '@mui/material';
import { useFormik } from 'formik';
import {React, useEffect, useState} from 'react'

import * as yup from 'yup';


// Access can arrive from the server as a number (0/1/2) or a word
// (None/Auto/Manual); normalize to the numeric value the form's selector uses.
function normalizeAccess(a) {
    if (a === 0 || a === 1 || a === 2) return a;
    if (a === '0') return 0;
    if (a === '1') return 1;
    if (a === '2') return 2;
    const s = String(a).trim().toLowerCase();
    if (s === 'none') return 0;
    if (s === 'auto') return 1;
    if (s === 'manual') return 2;
    return '';
}

export default function LocationForm(props)
{
    const selectedRedemptionPartnerId = props.RedemptionPartnerRow?.id;
    const[isAddOperation,setIsAddOperation] = useState(false);
    const[recvValues,setRecvValues] = useState({ id:'', name:'', created_at:'', });
    useEffect(()=>{

       if(props.selectedRow !== null )//&& valueLoaded === false)
       {
            console.log("Location Edit"+JSON.stringify(props.selectedRow));
            setRecvValues({
                id:props.selectedRow.id,
                name:props.selectedRow.name,
                    redemption_partner_id:props.selectedRow.redemption_partner_id || selectedRedemptionPartnerId,
                access: normalizeAccess(props.selectedRow.access),
            });

            setIsAddOperation(false);
        }
        else
        {
            setRecvValues({  id:'',name:'',
            redemption_partner_id:selectedRedemptionPartnerId,
            access: '',
            });
            setIsAddOperation(true);
        }

    },[props.selectedRow, selectedRedemptionPartnerId]);
    
    const validationSchema = yup.object({
        name: yup
            .string("AAA")
          .required('name is required'),
        redemption_partner_id: yup
            .mixed()
            .required('redemption partner is required'),
        access: yup
            .mixed()
            .test('access-required', 'access is required', (v) => v === 0 || v === 1 || v === 2 || v === '0' || v === '1' || v === '2'),
      });
      function onCancelForm()
      {
          //alert("Cancel");
          props.handleSubmit(null,isAddOperation,true)
      }
   
    //   const handleChange = (event) => {
    //     setRecvValues({
    //       ...recvValues,
    //       [event.target.name]: event.target.checked,
    //     });
    //   };
    
    const formik = useFormik({
        enableReinitialize:true,
        validateOnMount:true,
        validationSchema: validationSchema,
        initialValues:{
            id:recvValues?.id || '',
            name:recvValues?.name || '',
            redemption_partner_id:recvValues?.redemption_partner_id || selectedRedemptionPartnerId,
            access: recvValues?.access ?? '',
        },

        onSubmit:(values)=>{
           // alert("on submit");
            props.handleSubmit(values,isAddOperation,false);
           //this.resetForm();

        },
        // onReset:(values)=>{
        //     alert("Onreset");

        //     props.handleSubmit(null,isAddOperation,true)
        // }
    });

    const isSubmitDisabled = formik.isSubmitting || !formik.dirty || !formik.isValid;

    function handleRedemptionPartnerChange(event) {
        const selectedPartnerId = event.target.value;
        formik.setFieldValue('redemption_partner_id', selectedPartnerId);

        if (typeof props.onRedemptionPartnerChange === 'function' && Array.isArray(props.RedemptionPartnerList)) {
            const selectedPartner = props.RedemptionPartnerList.find(partner => String(partner.id) === String(selectedPartnerId)) || null;
            props.onRedemptionPartnerChange(selectedPartner);
        }
    }

    return(
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
            // <Paper >
            <form onSubmit={formik.handleSubmit} >
                {/* <Grid container spacing={2}> */}
                    <Grid item container xs={12} spacing={2}
                    justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                    alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            <Grid item xs={12} sm={6} md={5}>
                                <TextField
                                    select
                                    required
                                    fullWidth
                                    variant='outlined'
                                    id="redemption_partner_id"
                                    name="redemption_partner_id"
                                    label="Redemption Partner"
                                    value={formik.values.redemption_partner_id || ''}
                                    onBlur={formik.handleBlur}
                                    onChange={handleRedemptionPartnerChange}
                                    error={formik.touched.redemption_partner_id && Boolean(formik.errors.redemption_partner_id)}
                                    helperText={formik.touched.redemption_partner_id && formik.errors.redemption_partner_id}
                                >
                                    <MenuItem value="">Select redemption partner</MenuItem>
                                    {(props.RedemptionPartnerList || []).map(partner => (
                                        <MenuItem key={partner.id} value={partner.id}>
                                            {partner.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item  xs={12} sm={6} md={5}  >
                                <TextField
                                    required
                                    fullWidth
                                    variant='outlined'
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={5}>
                                <TextField
                                    select
                                    required
                                    fullWidth
                                    variant='outlined'
                                    id="access"
                                    name="access"
                                    label="Access"
                                    value={formik.values.access ?? ''}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    error={formik.touched.access && Boolean(formik.errors.access)}
                                    helperText={formik.touched.access && formik.errors.access}
                                >
                                    <MenuItem value={0}>None</MenuItem>
                                    <MenuItem value={1}>Auto</MenuItem>
                                    <MenuItem value={2}>Manual</MenuItem>
                                </TextField>
                            </Grid>
                            
                            

                    </Grid>
                    <Grid container item xs={12}
                     direction="row" spacing={3}
                      style={{ borderStyle: 'none', borderColor: 'black' }} justifyContent='flex-start'>
                        <Grid item >
                            <Button
                                type='submit'
                                variant='contained'
                                disabled={isSubmitDisabled}
                                style={{
                                    backgroundColor: isSubmitDisabled ? '#bdbdbd' : 'blue',
                                    color: isSubmitDisabled ? '#616161' : '#ffffff',
                                    opacity: 1,
                                    boxShadow: isSubmitDisabled ? 'none' : undefined,
                                    cursor: isSubmitDisabled ? 'not-allowed' : undefined
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button type='button' onClick={onCancelForm}  color='secondary' variant='contained' style={{backgroundColor: 'red !important', color: 'white'}}>Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
            // </Paper>
        // </Grid>


    );
}